<!--RIS-->
<!--v1.0-->
<!--患者详情-->
<!--宋增玲-->
<!--2018.08.09-->
<template>
  <div class="user-continer" v-loading='Loading' >
    <el-tabs v-model="activeName2" type="card" >
      <el-tab-pane label="个人资料" name="userInfo"></el-tab-pane>
      <el-tab-pane label="修改密码" name="userPassword"></el-tab-pane>
    </el-tabs>
    <el-row id="user-wrapper" class="user-wrapper">
      <div class="userinfo-continer" v-if='activeName2 === "userInfo"'>
        <div class="head-img">
          <div class="head-cont">
            <el-upload class="avatar-uploader" :before-upload="beforeAvatarUpload"  :action="postHeadImg" :show-file-list="false" :on-success="handleAvatarSuccess" :with-credentials = 'true'>
              <img v-if="userInfo.avatar" :src="userInfo.avatar" class="avatar">
              <img v-else src="../../assets/user-head.jpg" class="avatar">
              <el-button v-if="!userInfo.avatar" size="small" type="text" style="color:#3A4A64;margin-top: 50px;">选择头像</el-button>
              <el-button v-else size="small" type="text" style="color:#3A4A64;margin-top: 50px;">修改头像</el-button>
            </el-upload>
          </div>
        </div>
        <div class="form-cont">
          <el-form ref="form" size='mini' :model="submit" label-width="80px">
            <el-form-item label="姓名:">
              <span >{{userInfo.userName}} </span>
            </el-form-item>
            <el-form-item label="性别:">
              <!-- <el-radio-group disabled v-model="userInfo.sex"> -->
                <span v-if='userInfo.sex === 2'>男</span>
                <span  v-if='userInfo.sex === 3'>女</span>
                <!-- <el-radio :label='2'>男</el-radio>
                <el-radio :label='3'>女</el-radio> -->
              <!-- </el-radio-group> -->
            </el-form-item>
            <el-form-item label="出生日期:">
              <el-date-picker type="date" placeholder="选择日期" v-model="userInfo.birthDate" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="所属医院:">
              <span v-for='departRoleList in userInfo.departRoleList' :key='departRoleList.roleName'>{{departRoleList.hospName}} </span>
            </el-form-item>
            <el-form-item label="所属科室:">
              <span v-for='departRoleList in userInfo.departRoleList' :key='departRoleList.roleName'>{{departRoleList.departName}} </span>
            </el-form-item>
            <el-form-item label="职称:">
              <el-input v-model="userInfo.position"></el-input>
            </el-form-item>
            <el-form-item label="角色:">
              <span v-for='departRoleList in userInfo.departRoleList' :key='departRoleList.roleName'>{{departRoleList.roleName}} </span>
            </el-form-item>
            <el-form-item label="现住地址:">
              <el-input v-model="userInfo.address"></el-input>
            </el-form-item>
            <el-form-item label="登录账号:">
              <span >{{userInfo.userCode}} </span>
            </el-form-item>
            <el-form-item label="手机号:">
              <span v-if="inputFlag">
                <span> {{userInfo.mobile}} </span>
              </span>
              <span v-if="inputFlag">
                <el-button type="primary" v-if="userInfo.mobile!=''" @click="changeMobile(0)">修改</el-button>
                <el-button type="primary" v-else  @click="changeMobile(1)">新增</el-button>
              </span>
              <el-form-item v-if="!inputFlag" prop="Mobile">
                  <el-input style="width:180px;"  v-model="userInfo.Mobile" maxlength='11' placeholder="请输入11位手机号"></el-input>
              </el-form-item>
              <el-form-item v-if="!inputFlag" prop="SmsCode">
                    <el-input style="width:120px;" v-model="userInfo.SmsCode" placeholder="请输入验证码"></el-input>
                    <el-button class="sendvcode"  @click="onSendVcode">{{sendVCodeText}}</el-button>
              </el-form-item>
            </el-form-item>
            <el-form-item label="邮箱:">
              <el-input v-model="userInfo.email"></el-input>
            </el-form-item>
            <el-form-item label="擅长领域:">
              <el-input type="textarea" v-model="userInfo.speciality"></el-input>
            </el-form-item>
            <el-form-item label="个人简介:">
              <el-input type="textarea" v-model="userInfo.introduction"></el-input>
            </el-form-item>
            <el-form-item label="签名照片:">
              <!-- <el-upload
                class="upload-demo"
                :action="postWordImg"
                :with-credentials = 'true'
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                list-type="picture">
                <el-button size="small" type="primary">上传签名</el-button>
              </el-upload> -->
              <el-upload class="avatar-uploader qmuploader"  :before-upload="beforeUpload"  :action="postWordImg" :show-file-list="false" :on-success="handleSuccess" :on-error="handleError" :with-credentials = 'true'>
                <img v-if="userInfo.signature" :src="userInfo.signature" class="avatar">
                <div v-else><i class="el-icon-plus avatar-uploader-icon"></i></div>
                <el-button v-if="!userInfo.signature" size="small" type="text" style="color:#3A4A64;margin-top: 50px;">上传签名</el-button>
                <el-button v-else size="small" type="text" style="color:#3A4A64;margin-top: 50px;">修改签名</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="userinfo-continer" v-else>
        <div style="padding-top:20px;width:400px;margin-left:100px;">
          <el-form size='mini' :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="oldPwd">
              <el-input type="password" v-model="ruleForm2.oldPwd" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="新密码" prop="newPwd">
              <el-input type="password" v-model="ruleForm2.newPwd" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm2')">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
      <!-- <el-dialog :title="`${title}手机号`" :visible.sync="vcodeVisible" width="500px"  custom-class='revisitDialog' ref="dialog" v-if="vcodeVisible" @close="vcodeVisible=false">
        <el-form :model="form" key="form" ref="form" :rules="formRules">
          <el-form-item  prop="Mobile">
              <el-input style="width:380px;"  v-model="form.Mobile" placeholder="请输入11位手机号"></el-input>
          </el-form-item>
          <el-form-item prop="SmsCode">
                <el-input style="width:250px;" v-model="form.SmsCode" placeholder="请输入验证码"></el-input>
                <el-button class="sendvcode"  @click="onSendVcode">{{sendVCodeText}}</el-button>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" size="small" @click="determine">
              确定
            </el-button>
          </span>
        </template>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'user',
  data() {
    var validatePass = (rule, value, callback) => {
      let regx = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{9,}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if(!regx.test(value)){
        callback(new Error('需由包含大写字母、小写字母、数字且9位及以上组成'))
      } else {
        if (this.ruleForm2.checkPass !== '') {
          this.$refs.ruleForm2.validateField('checkPass')
        }

        if (value.length < 8) {
          callback(new Error('密码不能小于8位'))
        } else {
          callback()
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm2.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        if (value.length < 6) {
          callback(new Error('密码不能小于6位'))
        } else {
          callback()
        }
        callback()
      }
    }
    return {
      changeFlag:false,
      inputFlag:true,
      activeName2: 'userInfo',
      vcodeVisible:false,
      Loading: false,
      regId: '',
      scrollTop: 0,
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      submit: {
        birthDate: '',
        email: '',
        address: '',
        position: '',
        speciality: '',
        introduction: ''
      },
      postHeadImg: '',
      postWordImg: '',
      fileList: [],
      ruleForm2: {
        oldPwd: '',
        checkPass: '',
        newPwd: ''
      },
      rules2: {
        newPwd: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false, // 图片预览弹窗
      formLabelWidth: '80px',
      limitNum: 1,
      dialogVisible2: false,// 弹窗
      title:'新增',
      sendVCodeText: '发送验证码',
      form: {
        Mobile: '',
        SmsCode: ''
      },
      formRules:{
        Mobile: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
        SmsCode: [{ required: true, trigger: 'blur', message: '请输入验证码' }]
      },
      sendVCodeSecond:60
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created: function() {
    this.postHeadImg = this.$getCfg('VUE_APP_BASE_API') + '/User/UploadUserAvatar'
    this.postWordImg = this.$getCfg('VUE_APP_BASE_API') + '/User/UploadUserSignature'
    this.init()
  },
  methods: {
    //修改手机号
    changeMobile(type){
      this.title = type==0?'修改':'新增'
      this.vcodeVisible = true
      this.inputFlag = false
    },
    determine(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch('Login', this.form)
            .then(response => {

            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    onSendVcode() {
      var vm = this
      let mobile = this.userInfo.Mobile.trim()
      if (mobile === '') {
        this.$message.error('请输入手机号。')
        return false
      }
      if (mobile.length !== 11) {
        this.$message.error('手机号必须为11位。')
        return false
      }
      if (
        this.sendVCodeText === '发送验证码' ||
        this.sendVCodeText === '重新发送'
      ) {
        this.$store
          .dispatch('LoginSms', mobile)
          .then(response => {
            // 倒计时
            vm.setSendVCodeText(this.sendVCodeSecond)
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    setSendVCodeText(second) {
      var vm = this
      if (second > 0) {
        second--
        vm.sendVCodeText = '重新发送' + second + '秒'
        vm.$forceUpdate()
        setTimeout(function() {
          vm.setSendVCodeText(second)
        }, 1000)
      } else {
        this.sendVCodeText = '重新发送'
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 20000) {
        this.userInfo.avatar = 'data:image/jpeg;base64,' + res.data.imageBase64String
        this.$message.success('头像上传成功')
      } else {
        this.$message.error(res.message)
      }
    },
    handleSuccess(res, file) {
      if (res.code === 20000) {
        this.userInfo.signature = 'data:image/jpeg;base64,' + res.data.imageBase64String
        this.fileList = [{ name: 'signature', url: this.userInfo.signature }]
        this.$message.success('签名图片上传成功')
      } else {
        this.$message.error(res.message)
      }
    },
    handleError(res, file) {
      this.$message.error('签名图片上传失败')
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('请上传格式为image/png, image/jpg, image/jpeg的图片')
      }
      if (!isLt2M) {
        this.$message.error('上传签名图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    init: function() {
      this.Loading = true
      this.$store
        .dispatch('getUserSelfInfo')
        .then(() => {
          if (this.userInfo.avatar) {
            this.userInfo.avatar = 'data:image/jpeg;base64,' + this.userInfo.avatar
          }
          if (this.userInfo.signature) {
            this.userInfo.signature = 'data:image/jpeg;base64,' + this.userInfo.signature
            this.fileList = [{ name: 'signature', url: this.userInfo.signature }]
          }
          this.$forceUpdate()
          this.Loading = false
        })
        .catch(() => {
          this.Loading = false
        })
    },
    onSubmit() {
      this.submit = {
        birthDate: this.userInfo.birthDate,
        email: this.userInfo.email,
        address: this.userInfo.address,
        position: this.userInfo.position,
        speciality: this.userInfo.speciality,
        introduction: this.userInfo.introduction,
        Mobile: this.userInfo.Mobile,
        SmsCode: this.userInfo.SmsCode
      }
      this.$store
        .dispatch('updateUserSelfInfo', this.submit)
        .then(() => {
          this.Loading = false
          this.inputFlag = true
          this.userInfo.mobile = this.userInfo.Mobile
          this.$message.success('保存成功')
        })
        .catch(() => {
          this.Loading = false
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.Loading = true
          this.$store
            .dispatch('ChangeUserPwd', { newPwd: this.ruleForm2.newPwd, oldPwd: this.ruleForm2.oldPwd })
            .then(() => {
              this.Loading = false
              this.$store.dispatch('LogOut').then(() => {
                // 清除自动登录信息
                var loginAutoFromLocalStorage = localStorage.getItem('loginAuto')
                if (loginAutoFromLocalStorage) {
                  localStorage.removeItem('loginAuto')
                  localStorage.removeItem('userinfo')
                }
                location.reload()
              }).catch(() => {
                location.reload()
              })
            })
            .catch(() => {
              this.Loading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
    // 上传文件之前的钩子
  //   handleBeforeUpload (file) {
  //     if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
  //       this.$notify.warning({
  //         title: '警告',
  //         message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
  //       })
  //     }
  //     let size = file.size / 1024 / 1024 / 2
  //     if (size > 2) {
  //       this.$notify.warning({
  //         title: '警告',
  //         message: '图片大小必须小于2M'
  //       })
  //     }
  //     let fd = new FormData();//通过form数据格式来传
  //     fd.append("picFile", file); //传文件
  //     console.log(fd.get('picFile'));
  //     this.api({
  //       url: "/test/up",
  //       method: "post",
  //       data: fd,
  //       headers: {
  //         'Content-Type': 'multipart/form-data'
  //       }
  //     }).then((data) => {

  //     })
  //   },
  //   // 文件超出个数限制时的钩子
  //   handleExceed (files, fileList) {

  //   },
  //   // 文件列表移除文件时的钩子
  //   handleRemove (file, fileList) {
  //     this.hideUpload = fileList.length >= this.limitNum;

  //   },
  //   // 点击文件列表中已上传的文件时的钩子
  //   handlePictureCardPreview (file) {
  //     this.dialogImageUrl = file.url;
  //     this.dialogVisible = true;
  //   },
  //   uploadFile () {
  //     this.$refs.upload.submit()

  //   },
  //   imgChange (files, fileList) {
  //     this.hideUpload = fileList.length >= this.limitNum;
  //     if (fileList) {
  //       this.$refs.uploadElement.clearValidate();
  //     }
  //   },
  }
}
  </script>

  <style  rel="stylesheet/scss" lang="scss" scoped>
  .sendvcode {
    width: 90px;
    margin-left: 10px;
    border: 1px solid #397ee3;
    color: #397ee3;
    padding: 7px;
  }
  .user-continer{
    padding: 20px;
    overflow-y: auto;
    height:100%;
    transition: .5s;
    font-weight: normal !important;
    color:#3a4a64;
    .user-subheader{
      color: #3A4A64;
      height: 60px;
      line-height: 60px;
      border-bottom:2px solid #D8D8D8;;
      font-size: 18px;
      margin-bottom: 20px;
    }
    .main{
      overflow-y: -webkit-paged-x;
      //margin-top:20px;
      .el-menu{
        border:none;
        // height: calc(100vh - 110px);
        min-height: 400px;
        background-color: #f8f8f8;
        position: fixed;
        .el-menu-item{
          height: 40px;
          line-height: 40px;
          width: 155px;
          margin:20px;
          border-radius: 8px;
        }
      }
      .user-main{
        margin-left: 195px;
        padding:0 0 0 20px;
        .content-wrapper{
          border-top: 8px solid #D8E2F1;
          background: #f8f8f8;
        }
        .user-title{
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          font-weight: bold;
          border-bottom: 2px solid #D8E2F1;
          color:#3A4A64;
        }
        .user-content{
          padding: 40px 0;
          font-size: 14px;
          .content-item{
            height:50px;
            line-height: 50px;
            color:#3A4A64;
            .item-label{
              font-weight: normal;
              display:inline-block;
              width:120px;
              text-align: right;
            }
            .user-basicinfo{
              border: 1px solid #C8C8C8;
              border-radius: 5px;
              width:80%;
              margin:0 auto;
              padding: 10px 0;
              .basicinfo-item{
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
     .el-menu-item.is-active{
       background-color: #397EE3;
     }
  }
  .userinfo-continer{
    background: #f8f8f8;
    min-height: calc(100vh - 156px);
    .head-img{
      width: 240px;
      text-align: center;
      display: inline-block;
      float: left;
      .head-cont{
        margin-top: 20px;
        width: 160px;
        height: 260px;
        display: inline-block;
        border: 1px solid #C8C8C8;
      }
      .avatar{
        display: block;
        border-radius: 50%;
        border:1px solid #C8C8C8;
        width: 120px;
        height: 120px;
        margin-top: 20px;

      }
    }
    .form-cont{
      display: inline-block;
      margin-top: 20px;
    }

    .avatar-uploader{
      height: 100%;
      width: 100%;
      background: #fff;
      text-align: center;
    }
    .avatar-uploader .el-upload {
      width: 100%;
      height: 100%;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
      border: 1px dashed #d9d9d9;

    }
    .qmuploader{
      padding: 20px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
    }
    .avatar {
      width: 178px;
      // height: 178px;
      display: block;
    }
  }

  </style>
